import * as React from 'react';
import { FieldHookConfig, useField } from 'formik';
import {
  checkFormHasError,
  getFormSelectionControlsHelperTextState,
  handleBlurFormField,
  handleChangeFormField,
} from '@tock/shared/ui/forms/formHelpers';
import Checkbox, { CheckboxProps } from 'omakase/SelectionControls/Checkbox';

/**
 * (Formik) implementation of a checkbox.
 */
function FormCheckbox({ helperText, group, label, errorText, ...rest }: CheckboxProps) {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  const [field, meta] = useField({ ...rest } as FieldHookConfig<any>);

  const handleChange = (event: React.ChangeEvent<HTMLInputElement>) =>
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    handleChangeFormField(field, event, rest.onChange as (evt: React.ChangeEvent<any>) => void);

  const handleBlur = (event: React.FocusEvent<HTMLButtonElement>) =>
    handleBlurFormField(field, event, rest.onBlur);

  const hasError = checkFormHasError(meta);
  const {
    helperText: effectiveHelperText,
    errorText: effectiveErrorText,
    displayError,
  } = getFormSelectionControlsHelperTextState(meta, { hasError, helperText, group });

  return (
    <Checkbox
      {...rest}
      {...field}
      checked={group ? field.value.includes(rest.value) : field.value}
      value={group ? rest.value : field.value}
      onChange={handleChange}
      onBlur={handleBlur}
      label={label}
      error={displayError}
      helperText={effectiveHelperText}
      errorText={effectiveErrorText}
    />
  );
}

export default FormCheckbox;
